export default (values = [], options = [], sort = 'asc') => ({
    values: values,
    options: options,
    search: '',
    open: false,
    sort: sort,
    getDisplayValues() {
        let output = [];

        if (this.values.length > 0) {
            output.push(this.getOptionText(this.values[0]));
        }

        if (this.values.length > 1) {
            output.push('+ ' + (this.values.length - 1));
        }

        return output;
    },
    toggle() {
        if (this.open) {
            this.open = false;
            return;
        }

        this.open = true;
        this.$refs.search?.focus();
    },
    maybeRemoveValue() {
        if (this.search === '' && this.values.length > 0) {
            this.values.pop();
        }
    },
    clearValues() {
        this.values = [];
    },
    toggleAll() {
        if (this.values.length === this.options.length) {
            this.clearValues();
            return;
        }

        this.values = this.options.map((option) => option.value);
    },
    getOptionText(value) {
        let option = this.options.filter((option) => option.value == value);

        if (!option || !option[0] || !option[0].label) {
            return '';
        }

        return option[0].label;
    },
    /*
     * Sorted once and remembered. `Array.prototype.sort` sorts in place, so the
     * original was reordering the caller's own options array as a side effect of
     * being asked what to display — and it re-sorted the whole list on every
     * render, of which there are several per keystroke.
     */
    get sortedOptions() {
        const direction = this.sort === 'asc' ? 1 : -1;

        return [...this.options].sort(
            (a, b) => direction * String(a.label).localeCompare(String(b.label))
        );
    },

    getFilteredOptions() {
        const sortedOptions = this.sortedOptions;

        if (this.search === '') {
            return sortedOptions;
        }

        return sortedOptions
            .filter((option) => {
                return String(option.label)
                    .toLowerCase()
                    .includes(
                        this.search.toLowerCase()
                    );
            });
    },
    init() {
        this.$watch('values', () => {
            this.search = '';
            this.$refs.search?.focus();
        });
    }
});
